'use strict';

angular.module('bringgApp').controller('CustomerDropDownCtrl', function ($scope, Customers) {
	$scope.customers = Customers.all();
});
